import { setLinks } from '../../../renderer/setters';
var getAmpUrl = function (url) {
    if (url === void 0) { url = ''; }
    return url + (url.includes('?') ? '&' : '?') + '_amp_';
};
export var handleOldBlog = function (tags, siteLevelData) {
    if (siteLevelData === void 0) { siteLevelData = {}; }
    var _a = siteLevelData.hasBlogAmp, hasBlogAmp = _a === void 0 ? false : _a, _b = siteLevelData.context, _c = _b === void 0 ? {} : _b, _d = _c.defaultUrl, defaultUrl = _d === void 0 ? '' : _d;
    if (hasBlogAmp && defaultUrl.includes('/single-post/')) {
        return setLinks(tags, [
            {
                rel: 'amphtml',
                href: getAmpUrl(defaultUrl),
            },
        ]);
    }
    return tags;
};
